import { connect } from 'react-redux';

import ButtonPreview from '../../../components/Editor/ButtonPreview';
import { StoreState } from '../../../reducers';
import { Api } from '../../../typings/api';
import UrlUtils from '../../../utils/url';
import UserAgentUtils from '../../../utils/userAgent';

const mapStateToProps = (state: StoreState) => {
	const {
		routerParamsHistory,
		galleryInfos: { config },
		editor: { combo: { isCombining } },
	} = state;
	const { params: { resourceId } } = routerParamsHistory[routerParamsHistory.length - 1];
	const driveItem = {
		id: +resourceId,
	} as Api.DriveItem;

	return {
		url: UrlUtils.getPublicationUrl(config, driveItem, 1, UserAgentUtils.isMobileApp),
		isDisabled: isCombining,
	};
};

export default connect(mapStateToProps)(ButtonPreview);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/ButtonPreview/index.tsx